import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useAuthSession from "@/middleware/hooks/useAuthSession";
import LoadingScreen from "@/components/shared/LoadingScreen";

/**
 * Auth guard for the main app shell. Renders its children only when a session
 * is present; otherwise bounces to `/login` (without a return path — that is the
 * job of `MeetProtected`, which carries `{from}` for shareable deep links).
 *
 * Extracted verbatim from `App.tsx` so `RootRouteGuard` (and its tests) can
 * reuse it without importing App's full module graph. Behavior is unchanged.
 */
export const Protected = ({ children }: { children: React.JSX.Element }) => {
  const { t } = useTranslation();
  const { isLoggedIn, loading } = useAuthSession();
  if (loading) {
    return <LoadingScreen title={t("loading")} />;
  }
  return isLoggedIn ? children : <Navigate to="/login" />;
};

export default Protected;
